<!-- eslint-disable vue/no-v-html -->
<template>
  <div
    class="pvd-container"
  >
    <pvd-system-message
      v-if="displayRepAlert"
      placement="page"
      type="warning"
    >
      {{ displayRepAlert }}
    </pvd-system-message>
    <h1 class="pvd-heading-XXL text-center">
      {{ heading }}
    </h1>
    <p
      v-if="displayLede"
      class="text-center"
      v-html="lede"
    />
  </div>
</template>

<script>
import dataHelper from '../mixins/dataHelper';

export default {
  name: 'PageHeading',
  mixins: [dataHelper],
  props: {
    defaultHeading: {
      type: String,
      default: '',
    },
    editHeading: {
      type: String,
      default: '',
    },
    lede: {
      type: String,
      default: '',
    },
  },
  computed: {
    displayRepAlert() {
      let isRepMessage;
      if (this.cs_stateName !== 'login' && this.routeId === 'managed' && this.uc_isRep) {
        isRepMessage = this.pd_content.rep_web_view_message;
      }
      return isRepMessage;
    },
    heading() {
      let heading = this.cs_editMode ? this.editHeading : this.defaultHeading;
      if (this.editHeading === '') {
        heading = this.defaultHeading;
      }
      return heading;
    },
    displayLede() {
      return this.lede.length !== 0;
    },
  },
};
</script>

<style lang="scss">
</style>
